<template>
  <div class="user-cta">
    <Icon name="grCameraOff" width="36" class="mb-3"/>
    <div class="mb-5">
      <h4 class="user-cta__title">{{ $t('pages.checkins.sorry_no_photo_found') }}</h4>
      <h5 class="user-cta__subtitle" v-html="contactMessage"></h5>
    </div>
    <b-button class="user-cta__action has-icon" variant="primary" :href="contactUrl" target="_blank">
      <Icon name="send" width="24"/>
      {{ $t('pages.checkins.contact_us') }}
    </b-button>
  </div>
</template>

<script>
import {getContactUrl} from "@/utils";

export default {
  name: "CtaSupport",
  props: {
    eventName: {
      type: String,
      required: true
    },
    picaCode: {
      type: String,
      required: true
    }
  },
  computed: {
    contactUrl() {
      return getContactUrl(`${this.eventName} | ${this.picaCode}`)
    },
    contactMessage() {
      return this.$t('pages.checkins.contact_support_with_problem')
    },
  }
}
</script>


<style scoped>

</style>